// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftCircleFilledSvg from "@ant-design/icons-svg/es/asn/LeftCircleFilled";
import AntdIcon from '../components/AntdIcon';

var LeftCircleFilled = function LeftCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleFilledSvg
  }));
};

LeftCircleFilled.displayName = 'LeftCircleFilled';
export default React.forwardRef(LeftCircleFilled);